import { Inject, Injectable, OnInit, afterNextRender } from '@angular/core';
import { IntrackSdk } from '@core/models/DTOs/webengage-sdk';
import { Interface } from 'readline';

// declare var webengage: IWebEngageSdk;
declare var Intk: any;
export enum labels {}

@Injectable({
 providedIn: 'root',
})
export class WebengageService {
 labels: any = {
  45: 'iho+',
  36: 'فاصله کوتاه با مترو',
  44: 'اتاق ساعتی',
  33: 'هتل نوساز',
  38: 'هتل بازسازی شده',
 };

 accommodationType: any = {
  1: 'هتل',
  2: 'هتل آپارتمان',
  6: 'خانه، ویلا، سوییت',
  3: 'بومگردی',
  4: 'اقامتگاه',
  5: 'مهمان پذیر',
 };
 constructor() {
  afterNextRender(() => {
   try {
    //  if (![undefined, null, ''].includes((window as any).webengage))
    //   webengage.options('proxyURL', 'webengage.iho.co');
   } catch {}
  });
 }
 init(apiKey: string): void {}

 
 trackIntrack(eventName: string, properties?: Record<string, any>) {
  try {
    Intk('sendEvent', {
          eventName,
          eventData: properties
    });

  } catch (error) {
   console.log('error intrack', error);
  }
 }

 intrackLogin(user: any) {
  
  const userDetails = {
    "firstName": user.FirstName,
    "lastName": user.LastName,
    "email": user.Email,
    "phone": "+98" + user.Mobile,
    "country": "",
    "state": "",
    "city":  "",
    "gender": "other",
    "birthday": "",
    "company":  "",
    "hashedPhone": "",
    "hashedEmail": "",
    "smsOptIn": false,
    "emailOptIn": false,
    "pushOptIn": false,
    "webPushOptIn": false,
    "userId": user.sub,
    "attributes": {
      "userType": user.UserType,
      "registerType": user.RegisterType,
      "role": user.role
    }
  }
  
  try {
   if (Intk) Intk('login', userDetails);
   
  } catch (error) {
  }
 }

 screen(screenName: string, properties?: Record<string, any> | undefined): void {}

 onReady(callback: () => void): void {}

 userIdentify(userId: string, attributes?: Record<string, any> | undefined): void {}

 inTrackUserLogout(): void {
  try {
   if (Intk) Intk('logout') ;
  } catch {
   return;
  }
 }


 showNotification(message: string): void {}

 hideNotification(): void {}

 showSurvey(surveyId: string): void {}

 hideSurvey(): void {}

 showFeedback(): void {}

 hideFeedback(): void {}

 opennNtificationInbox(): void {}

 closeNotificationInbox(): void {}

 // loadWebEngageScript() {
 //   script.src = 'apps/ihowebsite/src/app/webengage-sdk.js';
 //   script.id = '_webengage_script_tag';
 //   script.type = 'text/javascript';
 //   document.head.appendChild(script);
 // }

 // createAttributes(type: Interface): Record<string, any> {}
}
